export class FpsMonitor {
  private readonly el: HTMLElement;
  private readonly valueEl: HTMLElement;
  private raf: number | null = null;
  private frames = 0;
  private since = 0;
  private visible = false;

  constructor(el: HTMLElement) {
    this.el = el;
    const value = el.querySelector<HTMLElement>('[data-fps-value]');
    if (!value) throw new Error('Missing FPS value element');
    this.valueEl = value;
    document.addEventListener('visibilitychange', () => {
      this.frames = 0;
      this.since = performance.now();
    });
  }

  setVisible(visible: boolean): void {
    this.visible = visible;
    this.el.hidden = !visible;
    if (visible) {
      this.start();
    } else {
      this.stop();
    }
  }

  private start(): void {
    if (this.raf !== null) return;
    this.frames = 0;
    this.since = performance.now();
    const tick = (now: number) => {
      if (!this.visible) {
        this.raf = null;
        return;
      }
      this.frames += 1;
      if (now - this.since >= 500) {
        const fps = Math.round((this.frames * 1000) / (now - this.since));
        this.valueEl.textContent = String(fps);
        this.el.dataset.tone = fps >= 50 ? 'good' : fps >= 28 ? 'fair' : 'poor';
        this.el.title = `${fps} FPS · ${window.innerWidth}×${window.innerHeight} @ ${window.devicePixelRatio.toFixed(2)}x`;
        this.frames = 0;
        this.since = now;
      }
      this.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  }

  private stop(): void {
    if (this.raf !== null) {
      cancelAnimationFrame(this.raf);
      this.raf = null;
    }
    this.valueEl.textContent = '--';
  }

  isVisible(): boolean {
    return this.visible;
  }
}
